export const Logo = ({ className = "h-8" }: { className?: string }) => {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        {/* Sygnet (Ikona W w stylu Huly) */}
        <svg
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-full w-auto text-white"
        >
          <rect width="40" height="40" rx="10" fill="currentColor" fillOpacity="0.1" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 12C12 10.8954 12.8954 10 14 10H18C19.1046 10 20 10.8954 20 12V22H20.01L22 16H26L28 22H28.01V12C28.01 10.8954 28.9054 10 30.01 10H34.01C35.1146 10 36.01 10.8954 36.01 12V28C36.01 29.1046 35.1146 30 34.01 30H28.01C26.9054 30 26.01 29.1046 26.01 28V24L24 30H16L14 24V28C14 29.1046 13.1046 30 12 30H6C4.89543 30 4 29.1046 4 28V12C4 10.8954 4.89543 10 6 10H10C11.1046 10 12 10.8954 12 12Z"
            fill="currentColor"
          />
        </svg>
        
        {/* Nazwa firmy - Typografia w stylu Huly */}
        <div className="flex flex-col justify-center leading-none">
          <span className="font-bold text-xl tracking-tight text-white">
            webpol
          </span>
          <span className="text-[10px] font-medium tracking-widest uppercase text-gray-400">
            solutions
          </span>
        </div>
      </div>
    );
  };